import React from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import Root from './root';
import './category-analytics';

// Next line disables GTM feature "Wait For Tags" feature
// which is not suitable for Single Page Applications
// as it forces full page reload on every in-app link click.
// The "Wait For Tags" feature can be disabled in GTM configuration console
// or with the following code.
const lcl = get(window, 'google_tag_manager.autoEventsSettings.lcl');
if (lcl) {
    lcl.mwt = 0;
}

ReactDOM.render(<Root />, document.getElementById('app'));
